const TRANSLATION_STATUS_FIELDS: Record<string, string> = {
  html_section: "html_status",
  accordion_section: "accordion_status",
  tabs_section: "tabs_section_status",
  banner_section: "banner_status",
  destini_locator: "destini_locator_status",
  coupon: "coupon_status",
};

const PARENT_STATUS_COLLECTIONS = new Set([
  "pills_section",
  "table_with_image_section",
  "comparison_section",
]);

const NO_STATUS_COLLECTIONS = new Set([
  "text_with_background_image",
  "video_cards_carousel",
  "infinite_horizontal_cards",
  "quote_cards",
]);

const DEFAULT_PUBLISHED_STATUS = "published";

export type SectionListItem = {
  collection?: string;
  collection_id?: {
    status?: string;
    translations?: Record<string, string>[];
  };
  item?: {
    translations?: Record<string, string>[];
  };
  status?: string;
};

export const getSectionLocaleStatus = (
  section: SectionListItem,
): string | undefined => {
  const { collection, collection_id: collectionId } = section;

  if (!collection) {
    return undefined;
  }

  if (NO_STATUS_COLLECTIONS.has(collection)) {
    return DEFAULT_PUBLISHED_STATUS;
  }

  if (PARENT_STATUS_COLLECTIONS.has(collection)) {
    return collectionId?.status;
  }

  const translation =
    collectionId?.translations?.[0] ??
    section?.item?.translations?.[0];

  const statusField =
    TRANSLATION_STATUS_FIELDS[collection] ?? "status";

  return translation?.[statusField] as string | undefined;
};

export const enrichSectionsWithStatus = <T extends SectionListItem>(
  sectionsList: T[] | undefined | null,
): T[] | undefined | null => {
  if (!sectionsList) {
    return sectionsList;
  }

  return sectionsList.map((section) => ({
    ...section,
    status: getSectionLocaleStatus(section),
  }));
};
